import {NgModule} from '@angular/core';
import {DeaRegistrationService} from './dea-registration.service';
import {DeaRegistrationInformationService} from './info/dea-registration-information.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [
        DeaRegistrationService,
        DeaRegistrationInformationService
    ]
})
export class DeaRegistrationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/dea/dea-registration.module.ts